import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../Modal";
import { useEffect } from "react";

const TextsVideoTwo = ({
  setTextOneVideoTwo,
  textOneVideoTwo,
  setImgOneVideoTwo,
  setTextThreeVideoTwo,
  textThreeVideoTwo,
  setTextFiveVideoTwo,
  textFiveVideoTwo,
  setImgTwoVideoTwo,
  setImgThreeVideoTwo,
  setImgFourVideoTwo,
  setImgFiveVideoTwo,
  setTextColorOne,
  setTextColorTwo,
  setTextColorThree,

  imgOneVideoTwo,
  imgTwoVideoTwo,
  imgThreeVideoTwo,
  imgFourVideoTwo,
  imgFiveVideoTwo,
}) => {
  const [modal, setModal] = useState(false);
  const [img_modal, setImg_modal] = useState();
  const [numerImage, setNumerImage] = useState("0");
  const [isChanging, setIsChanging] = useState(false);

  const [animDisable, setAnimDisable] = useState(false);

  const [isImgOne, setIsImgOne] = useState(false);
  const [isImgTwo, setIsImgTwo] = useState(false);
  const [isImgThree, setIsImgThree] = useState(false);
  const [isImgFour, setIsImgFour] = useState(false);
  const [isImgFive, setIsImgFive] = useState(false);

  const [previewImgs, setPreviewImgs] = useState();

  const [prevOne, setPrevOne] = useState();
  const [prevTwo, setPrevTwo] = useState();
  const [prevThree, setPrevThree] = useState();
  const [prevFour, setPrevFour] = useState();
  const [prevFive, setPrevFive] = useState();

  const [colorSelected, setColorSelected] = useState("");
  const [colorSelectedTwo, setColorSelectedTwo] = useState("");
  const [colorSelectedThree, setColorSelectedThree] = useState("");
  useEffect(() => {
    if (numerImage === "1") {
      setImgOneVideoTwo(img_modal);
      setPrevOne(previewImgs);
    } else if (numerImage === "2") {
      setImgTwoVideoTwo(img_modal);
      setPrevTwo(previewImgs);
    } else if (numerImage === "3") {
      setImgThreeVideoTwo(img_modal);
      setPrevThree(previewImgs);
    } else if (numerImage === "4") {
      setImgFourVideoTwo(img_modal);
      setPrevFour(previewImgs);
    } else if (numerImage === "5") {
      setImgFiveVideoTwo(img_modal);
      setPrevFive(previewImgs);
    }

    setPreviewImgs();
  }, [isChanging]);

  const navigate = useNavigate();

  const changePage = () => {
    const anims_left = document.querySelector(".anim_slider");
    anims_left.classList.remove("animate__bounceInRight");
    anims_left.classList.add("animate__bounceOutLeft");

    setTimeout(() => {
      navigate("/render-video-dos");
    }, 1000);
  };

  const changePagePrev = (rute) => {
    const anims_left = document.querySelector(".anim_slider");
    anims_left.classList.remove("animate__bounceInRight");
    anims_left.classList.add("animate__bounceOutLeft");
    setTimeout(() => {
      navigate(rute);
    }, 1000);
  };

  useEffect(() => {
    if (colorSelected) {
      handleControllerColor(colorSelected, 1);
    }
    if (colorSelectedTwo) {
      handleControllerColor(colorSelectedTwo, 2);
    }
    if (colorSelectedThree) {
      handleControllerColor(colorSelectedThree, 3);
    }
  }, [isChanging]);

  const handleControllerColor = (color, p) => {
    if (p === 1) {
      document.querySelector(".c1p1").classList.remove("c_active");
      document.querySelector(".c2p1").classList.remove("c_active");
      document.querySelector(".c3p1").classList.remove("c_active");
      document.querySelector(".c4p1").classList.remove("c_active");
      document.querySelector(color).classList.add("c_active");
    } else if (p === 2) {
      document.querySelector(".c1p2").classList.remove("c_active");
      document.querySelector(".c2p2").classList.remove("c_active");
      document.querySelector(".c3p2").classList.remove("c_active");
      document.querySelector(".c4p2").classList.remove("c_active");
      document.querySelector(color).classList.add("c_active");
    } else if (p === 3) {
      document.querySelector(".c1p3").classList.remove("c_active");
      document.querySelector(".c2p3").classList.remove("c_active");
      document.querySelector(".c3p3").classList.remove("c_active");
      document.querySelector(".c4p3").classList.remove("c_active");
      document.querySelector(color).classList.add("c_active");
    }
  };

  const checkInputFiels = () => {
    if (!imgOneVideoTwo) {
      setIsImgOne(true);
    } else {
      setIsImgOne(false);
    }
    if (!imgTwoVideoTwo) {
      setIsImgTwo(true);
    } else {
      setIsImgTwo(false);
    }
    if (!imgThreeVideoTwo) {
      setIsImgThree(true);
    } else {
      setIsImgThree(false);
    }
    if (!imgFourVideoTwo) {
      setIsImgFour(true);
    } else {
      setIsImgFour(false);
    }
    if (!imgFiveVideoTwo) {
      setIsImgFive(true);
    } else {
      setIsImgFive(false);
    }

    if (
      imgOneVideoTwo &&
      imgTwoVideoTwo &&
      imgThreeVideoTwo &&
      imgFourVideoTwo &&
      imgFiveVideoTwo
    ) {
      changePage();
    }
  };

  return (
    <section>
      {modal ? (
        <Modal
          setPreviewImgs={setPreviewImgs}
          setModal={setModal}
          modal={modal}
          setImg_modal={setImg_modal}
          setIsChanging={setIsChanging}
          isChanging={isChanging}
        />
      ) : (
        <div className="texts_video_two">
          <div
            className={`texts_video_two_container containerAll anim_slider animate__animated ${
              !animDisable ? "  animate__bounceInRight" : ""
            } `}
          >
            <h1 className="title title2">Galería Musicalizada</h1>
            <div className="content_steps">
              <div className="content_circles">
                <div
                  onClick={() => changePagePrev("/formulario")}
                  className="circle pointer"
                ></div>
                <div
                  onClick={() => changePagePrev("/selecciona-audio-dos")}
                  className="circle pointer"
                ></div>
                <div className="circle"></div>
              </div>
              <h2> Paso 3 de 3</h2>
            </div>
            <p className="text_one">
              ¡Elige las imágenes, escribe el texto y selecciona el color que más te guste
              en tu galería musicalizada!
            </p>

            <div className="content_imgs">
              <div className="imgs_texts ">
                <h3 className="number">1</h3>
                <div className="group">
                  <div className="flex_img">
                    <div className="group_one">
                      <p>Ingresar Imagen</p>
                      <label
                        onClick={() => {
                          setModal(!modal);
                          setAnimDisable(true);
                          setNumerImage("1");
                        }}
                        htmlFor="img1"
                      >
                        Seleccionar archivo
                        <img src="/assets/subir_rosado.png" alt="" />
                      </label>
                    </div>

                    {imgOneVideoTwo || prevOne ? (
                      <div>
                        {imgOneVideoTwo && !prevOne && (
                          <img
                            className="preview_img"
                            src={imgOneVideoTwo}
                            alt="imagen"
                          />
                        )}
                        {prevOne && (
                          <img className="preview_img" src={prevOne} alt="imagen" />
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <label className="input_text input">
                    Ingresar texto
                    <textarea
                      maxLength="80"
                      value={textOneVideoTwo}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const sanitizedValue = inputValue.replace(/[^A-Za-z0-9\s]/g, ""); // Permitir letras, números y espacios
                        setTextOneVideoTwo(sanitizedValue);
                      }}
                      type="text"
                      pattern="[A-Za-z]+"
                    />
                  </label>
                  <p className="title_colors">Color de texto</p>
                  <div className="colors">
                    <div
                      onClick={() => {
                        setTextColorOne("#efe9e5");
                        handleControllerColor(".c1p1", 1);
                        setColorSelected(".c1p1");
                      }}
                      className="color_white c1p1"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorOne("#8063c6");
                        handleControllerColor(".c2p1", 1);
                        setColorSelected(".c2p1");
                      }}
                      className="color_purple c2p1"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorOne("#ff9f4b");
                        handleControllerColor(".c3p1", 1);
                        setColorSelected(".c3p1");
                      }}
                      className="color_orange c3p1"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorOne("#31d0d6");
                        handleControllerColor(".c4p1", 1);
                        setColorSelected(".c4p1");
                      }}
                      className="color_blue c4p1"
                    ></div>
                  </div>

                  {isImgOne ? (
                    <div className="error">
                      <p>Por favor ingresa todos los campos</p>
                      <img src="/assets/icons/error.png" alt="" />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="imgs_texts card_two">
                <h3 className="number">2</h3>
                <div className="group">
                  <div className="flex_img">
                    <div className="group_one">
                      <p>Ingresar Imagen</p>

                      <label
                        onClick={() => {
                          setModal(!modal);
                          setAnimDisable(true);
                          setNumerImage("2");
                        }}
                        htmlFor="img2"
                      >
                        Seleccionar archivo
                        <img src="/assets/subir_naranja.png" alt="" />
                      </label>
                    </div>
                    {imgTwoVideoTwo || prevTwo ? (
                      <div>
                        {imgTwoVideoTwo && !prevTwo && (
                          <img
                            className="preview_img"
                            src={imgTwoVideoTwo}
                            alt="imagen"
                          />
                        )}
                        {prevTwo && (
                          <img className="preview_img" src={prevTwo} alt="imagen" />
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {isImgTwo ? (
                    <div className="error">
                      <p>Por favor añade una imagen</p>
                      <img src="/assets/icons/error.png" alt="" />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="imgs_texts">
                <h3 className="number">3</h3>
                <div className="group">
                  <div className="flex_img">
                    <div className="group_one">
                      <p>Ingresar Imagen</p>
                      <label
                        onClick={() => {
                          setModal(!modal);
                          setAnimDisable(true);
                          setNumerImage("3");
                        }}
                        htmlFor="img3"
                      >
                        Seleccionar archivo
                        <img src="/assets/subir_rosado.png" alt="" />
                      </label>
                    </div>
                    {imgThreeVideoTwo || prevThree ? (
                      <div>
                        {imgThreeVideoTwo && !prevThree && (
                          <img
                            className="preview_img"
                            src={imgThreeVideoTwo}
                            alt="imagen"
                          />
                        )}
                        {prevThree && (
                          <img className="preview_img" src={prevThree} alt="imagen" />
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <label className="input_text input">
                    Ingresar texto
                    <textarea
                      maxLength="80"
                      value={textThreeVideoTwo}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const sanitizedValue = inputValue.replace(/[^A-Za-z0-9\s]/g, ""); // Permitir letras, números y espacios
                        setTextThreeVideoTwo(sanitizedValue);
                      }}
                      type="text"
                    />
                  </label>
                  <p className="title_colors">Color de texto</p>
                  <div className="colors">
                    <div
                      onClick={() => {
                        setTextColorTwo("#efe9e5");
                        handleControllerColor(".c1p2", 2);
                        setColorSelectedTwo(".c1p2");
                      }}
                      className="color_white c1p2"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorTwo("#8063c6");
                        handleControllerColor(".c2p2", 2);
                        setColorSelectedTwo(".c2p2");
                      }}
                      className="color_purple c2p2"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorTwo("#ff9f4b");
                        handleControllerColor(".c3p2", 2);
                        setColorSelectedTwo(".c3p2");
                      }}
                      className="color_orange c3p2"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorTwo("#31d0d6");
                        handleControllerColor(".c4p2", 2);
                        setColorSelectedTwo(".c4p2");
                      }}
                      className="color_blue c4p2"
                    ></div>
                  </div>

                  {isImgThree ? (
                    <div className="error">
                      <p>Por favor ingresa todos los campos</p>
                      <img src="/assets/icons/error.png" alt="" />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="imgs_texts card_two">
                <h3 className="number">4</h3>
                <div className="group">
                  <div className="flex_img">
                    <div className="group_one">
                      <p>Ingresar Imagen</p>
                      <label
                        onClick={() => {
                          setModal(!modal);
                          setAnimDisable(true);
                          setNumerImage("4");
                        }}
                        htmlFor="img4"
                      >
                        Seleccionar archivo
                        <img src="/assets/subir_naranja.png" alt="" />
                      </label>
                    </div>

                    {imgFourVideoTwo || prevFour ? (
                      <div>
                        {imgFourVideoTwo && !prevFour && (
                          <img
                            className="preview_img"
                            src={imgFourVideoTwo}
                            alt="imagen"
                          />
                        )}
                        {prevFour && (
                          <img className="preview_img" src={prevFour} alt="imagen" />
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {isImgFour ? (
                    <div className="error">
                      <p>Por favor añade una imagen</p>
                      <img src="/assets/icons/error.png" alt="" />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="imgs_texts">
                <h3 className="number">5</h3>
                <div className="group">
                  <div className="flex_img">
                    <div className="group_one">
                      <p>Ingresar Imagen</p>
                      <label
                        onClick={() => {
                          setModal(!modal);
                          setAnimDisable(true);
                          setNumerImage("5");
                        }}
                        htmlFor="img5"
                      >
                        Seleccionar archivo
                        <img loading="lazy" src="/assets/subir_rosado.png" alt="" />
                      </label>
                    </div>
                    {imgFiveVideoTwo || prevFive ? (
                      <div>
                        {imgFiveVideoTwo && !prevFive && (
                          <img
                            loading="lazy"
                            className="preview_img"
                            src={imgFiveVideoTwo}
                            alt="imagen"
                          />
                        )}
                        {prevFive && (
                          <img
                            loading="lazy"
                            className="preview_img"
                            src={prevFive}
                            alt="imagen"
                          />
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <label className="input_text input">
                    Ingresar texto
                    <textarea
                      maxLength="80"
                      value={textFiveVideoTwo}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        const sanitizedValue = inputValue.replace(/[^A-Za-z0-9\s]/g, ""); // Permitir letras, números y espacios
                        setTextFiveVideoTwo(sanitizedValue);
                      }}
                      type="text"
                    />
                  </label>
                  <p className="title_colors">Color de texto</p>
                  <div className="colors">
                    <div
                      onClick={() => {
                        setTextColorThree("#efe9e5");
                        handleControllerColor(".c1p3", 3);
                        setColorSelectedThree(".c1p3");
                      }}
                      className="color_white c1p3"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorThree("#8063c6");
                        handleControllerColor(".c2p3", 3);
                        setColorSelectedThree(".c2p3");
                      }}
                      className="color_purple c2p3"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorThree("#ff9f4b");
                        handleControllerColor(".c3p3", 3);
                        setColorSelectedThree(".c3p3");
                      }}
                      className="color_orange c3p3"
                    ></div>
                    <div
                      onClick={() => {
                        setTextColorThree("#31d0d6");
                        handleControllerColor(".c4p3", 3);
                        setColorSelectedThree(".c4p3");
                      }}
                      className="color_blue c4p3"
                    ></div>
                  </div>

                  {isImgFive ? (
                    <div className="error">
                      <p>Por favor ingresa todos los campos</p>
                      <img loading="lazy" src="/assets/icosns/error.png" alt="" />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            <div className="button_one">
              <button onClick={checkInputFiels}>Continuar</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TextsVideoTwo;
